<template>
  <div class="public-start-view content">
    <h1 class="title is-1 line-under is-spaced" v-translate>Thank you for your application!</h1>
    <h3 class="subtitle is-4" v-translate>This is what happens next</h3>
    <ol>
      <li v-translate='{email: get_email}'>We will send you a confirmation letter to the e-mail adress
        <strong>%{email}</strong>. If you do not recieve this e-mail the you need to contact Kiwa Certification Building and Energy but please check in your spam folder before doing so.
      </li>
      <li v-translate>In order to confirm your application you need to click on the link in the e-mail and choose a password. We will not start the process until the application is confirmed.</li>
      <li v-translate>The system will verify your application and if something is missing you will be requested to resolve any missing information.</li>
      <li v-translate>An auditor will be assigned to your case and will go through all sent in documents.</li>
      <li v-translate>If the auditor can validate all sent in documentation a certification will be issued and sent to your e-mail address.</li>
    </ol>
    <p v-translate>
      If you have any questions please do not hesitate to contact us on <strong>bygg@kiwa.com</strong> or <strong>0455-305600</strong>.
    </p>

    <router-link :to="{ name: 'WelcomeView'}" v-translate>Go to start page</router-link>
  </div>
</template>
<script>
  export default {
    name: 'thank-you-view',
    props: {
      email: {
        required: false,
        default: 'which you applied with'
      }
    },
    computed: {
      get_email () {
        return this.$gettext(this.email)
      }
    }
  }
</script>
